<template>
    <div class="video-js-responsive-container vjs-hd">
        <video :autoplay="shouldAutoPlay" ref="videoPlayer" class="video-js" controls preload="auto"></video>
    </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    shouldAutoPlay: {
    	type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  computed: {
    currentPlayTime() {
      if (this.player !== null) return this.player.currentTime();
      return null;
    },
  },
  watch: {
    currentPlayTime(seconds) {
      const floored = Math.floor(seconds);

      if (this.$store.getters.getVideoTimestamp !== floored) this.$store.commit('setVideoTimestamp', floored);
    },
  },
  mounted() {
    this.$store.commit('setVideoTimestamp', 0);
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.$store.commit('setVideoTimestamp', 0);
      this.player.dispose();
    }
  },
};
</script>

<style>
    .video-js-responsive-container.vjs-hd {
        padding-top: 56.25%;
    }
    .video-js-responsive-container.vjs-sd {
        padding-top: 75%;
    }
    .video-js-responsive-container {
        position: relative;
    }
    .video-js-responsive-container .video-js {
        height: calc(100% - 39px) !important;
        width: 100% !important;
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
